import React, { useCallback } from 'react';
import { history } from 'ice';
import { LogoutOutlined } from '@ant-design/icons';
import { Icon } from '@b-design/fusion';
import { Dropdown, Avatar } from 'antd';
import type { MenuInfo } from 'rc-menu/lib/interface';
import styles from './index.module.css';
import NameIcon from '../NameIcon';
import { logout } from '@/services/user';
import store from '@/store';
import $i18n from '../../i18n';

interface AvatarDropdownProps {
  name: string;
  avatar: string;
  onMenuReset: () => void;
}

const AvatarDropdown: React.FC<AvatarDropdownProps> = ({ name, avatar, onMenuReset}) => {
  const [, userDispatcher] = store.useModel('user');

  const loginOut = async () => {
    await logout();
    onMenuReset && onMenuReset();
    history?.push({
      pathname: '/login',
    });
  };

  const onMenuClick = useCallback((event: MenuInfo) => {
    const { key } = event;
    if (key === 'logout') {
      userDispatcher.updateCurrentUser({});
      loginOut();
    }
  }, []);

  const menu = {
    items: [
      {
        key: 'logout',
        label: $i18n.get({ id: 'aopf.components.AvatarDropdown.LogOut', dm: '退出登录' }),
        icon: <LogoutOutlined />,
        onClick: onMenuClick,
        className: styles.menu,
      },
    ],
  };

  return (
    <div className={styles.jump}>
      <Dropdown menu={menu}>
        <span className={`${styles.action} ${styles.account}`}>
          {avatar ? (
            <Avatar size="small" className={styles.avatar} src={avatar} alt="avatar" />
          ) : (
            <NameIcon
              name={name}
              styles={{ marginRight: 8, color: '#0A2361', backgroundColor: 'var(--superapp-secondary-1)' }}
            />
          )}
          <span>{name}</span>
        </span>
      </Dropdown>
    </div>
  );
};

export default AvatarDropdown;
